import { render, staticRenderFns } from "./FolderItem.vue?vue&type=template&id=d5fafd90&scoped=true"
import script from "./FolderItem.vue?vue&type=script&lang=js"
export * from "./FolderItem.vue?vue&type=script&lang=js"
import style0 from "./FolderItem.vue?vue&type=style&index=0&id=d5fafd90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fafd90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5fafd90')) {
      api.createRecord('d5fafd90', component.options)
    } else {
      api.reload('d5fafd90', component.options)
    }
    module.hot.accept("./FolderItem.vue?vue&type=template&id=d5fafd90&scoped=true", function () {
      api.rerender('d5fafd90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content/ContentView/FolderItem.vue"
export default component.exports